<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/banner3.png" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>集团介绍</h3>
            <p>Group Introduction</p>
          </dt>
          <dd class="w25">
            <router-link to="Intro" class="active"><span>企业简介</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Architecture"><span>企业架构</span><i class="el-icon-arrow-right"></i></router-link>
          </dd class="w25">
          <dd class="w25">
            <router-link to="Culture"><span>企业文化</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="DevelopmentCourse"><span>发展历程</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Responsibility"><span>社会责任</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>集团介绍</h2>/<i>企业简介</i>
        </div>
        <div class="news-article">
          <div v-html="content"></div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'Intro',
    data() {
      return {
        content: ''
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    mounted() {
       axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=企业简介').then((response) => {
          this.content = response.data.subject.result[0].content;
       });
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue